import { useState, useEffect, useRef } from 'react';

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showModal, setShowModal] = useState(false);
  const hasBeenNotifiedRef = useRef(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowModal(false);
      hasBeenNotifiedRef.current = false;
    };

    const handleOffline = () => {
      setIsOnline(false);
      if (!hasBeenNotifiedRef.current) {
        setShowModal(true);
        hasBeenNotifiedRef.current = true;
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    if (!navigator.onLine && !hasBeenNotifiedRef.current) {
      setShowModal(true);
      hasBeenNotifiedRef.current = true;
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const closeModal = () => {
    setShowModal(false);
  };

  return { isOnline, showModal, setShowModal: closeModal };
};